// extracted by mini-css-extract-plugin
var _1 = "styles-module__consentOption___id_KP";
var _2 = "styles-module__label___QdsiZ";
var _3 = "styles-module__radio___TeQqi";
var _4 = "styles-module__rectangle___kNESn";
export { _1 as "consentOption", _2 as "label", _3 as "radio", _4 as "rectangle" }
